import { Component, Input, ViewChild } from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'cxone-games-connect-3-slot',
  templateUrl: './cxone-games-connect-3-slot.component.html',
  styleUrl: './cxone-games-connect-3-slot.component.scss'
})
export class CxoneGamesConnect3SlotComponent {
  @Input() slotType: string;
  @Input() tooltipTitle: string;
  @Input() tooltipTarget: string;
  @Input() tooltipTargetDirection: number;
  @ViewChild('tooltipConnect3', { static: false }) tooltipConnect3!: NgbPopover; 
  @ViewChild('tooltipConnect3Completed', { static: false }) tooltipConnect3Completed!: NgbPopover; 

  hideTooltip() {
    if (this.tooltipConnect3) {
        this.tooltipConnect3.close();
    }
    
    if (this.tooltipConnect3Completed) {
        this.tooltipConnect3Completed.close();
    }
  }

}